// extracted by mini-css-extract-plugin
module.exports = {"main":"NotificationListWithPolling_main__3xVP8","loadButton":"NotificationListWithPolling_loadButton__1zbVC","loading":"NotificationListWithPolling_loading__3MV10"};